import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IField, defaultValue } from 'app/shared/model/field.model';
import { apiOkr } from 'app/config/axios-interceptor';
import qs from 'qs';

const initialState: EntityState<IField> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/okr/contribution';
// Actions

type IPayloadContribution = {
  contributionViewType: number;
  planPeriodId: string | number;
  adjustmentPeriod?: string;
  accountableId?: string;
};

export const getEntities = createAsyncThunk(
  'contribution/fetch_entity_list',
  async ({ contributionViewType, planPeriodId, adjustmentPeriod, accountableId }: IPayloadContribution) => {
    return apiOkr.get<any>(`${apiUrl}`, {
      params: {
        contributionViewType,
        planPeriodId,
        adjustmentPeriod,
        accountableId,
      },
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  },
  { serializeError: serializeAxiosError },
);

export const updateEntity = createAsyncThunk(
  'contribution/update_entity',
  async (entity: IField[], thunkAPI) => {
    const result = await apiOkr.put<IField[]>(`${apiUrl}`, entity);
    return result;
  },
  { serializeError: serializeAxiosError },
);
// slice

export const ContributionSlice = createEntitySlice({
  name: 'contribution',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getEntities), (state, action) => {
        const { data, headers } = action.payload;

        return {
          ...state,
          loading: false,
          entities: data.objectives,
        };
      })
      .addMatcher(isFulfilled(updateEntity), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
      })
      .addMatcher(isPending(getEntities), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
        state.entities = [];
      })
      .addMatcher(isPending(updateEntity), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      });
  },
});

export const { reset } = ContributionSlice.actions;

// Reducer
export default ContributionSlice.reducer;
